import React, { useState, useEffect } from 'react';
import FriDaveHeader from './FriDaveHeader';
import FriDaveBottomNav from './FriDaveBottomNav';
import SplashScreen from './SplashScreen';

export default function FriDaveLayout({ children }) {
  const [showSplash, setShowSplash] = useState(false);
  const [splashDone, setSplashDone] = useState(false);

  useEffect(() => {
    // Only show once per browser session (handles SPA navigation re-mounts)
    if (sessionStorage.getItem('fridave_splash_shown')) return;

    if (!('BroadcastChannel' in window)) {
      // No cross-tab support — show splash and mark as shown
      sessionStorage.setItem('fridave_splash_shown', '1');
      setShowSplash(true);
      return;
    }

    const channel = new BroadcastChannel('fridave_app');
    let otherTabFound = false;

    channel.onmessage = (event) => {
      if (event.data.type === 'ping') channel.postMessage({ type: 'pong' });
      if (event.data.type === 'pong') otherTabFound = true;
    };

    // Ask if any other tabs have the app open
    channel.postMessage({ type: 'ping' });

    // Wait briefly for a response
    const checkTimer = setTimeout(() => {
      channel.close();
      if (!otherTabFound) {
        sessionStorage.setItem('fridave_splash_shown', '1');
        setShowSplash(true);
      }
    }, 200);

    return () => {
      clearTimeout(checkTimer);
      channel.close();
    };
  }, []);

  return (
    <div className="min-h-screen bg-fd-cream flex flex-col">
      {showSplash && !splashDone && (
        <SplashScreen onDone={() => setSplashDone(true)} />
      )}
      <FriDaveHeader />
      <main className="flex-1 w-full py-4 pb-24">
        <div className="max-w-xl mx-auto">
          {children}
        </div>
      </main>
      <FriDaveBottomNav />
    </div>
  );
}
